import React, { Component } from "react";
import { Mutation } from "react-apollo";
import { Row, Col, Divider } from "antd";
import _ from "lodash";

import StepsForm from "./StepsForm";
import FormProgress from "./FormProgress";
import UpdateOrderStatus from "../../GraphQL/Mutation/UpdateOrderStatus";
import UserContext from "../../Contexts/UserContext";
import TermsModal from "./TermsModal";

class ServiceRequest extends Component {
  state = {
    currentStep: 0,
    parsedValues: {}
  };

  componentDidMount() {
    const {
      order: { fields }
    } = this.props;

    const stepField = [];
    _.map(fields, field => {
      if (field.value) {
        stepField.push(field.step);
      }
    });
    this.setState({ currentStep: _.max(stepField) - 1 || 0 });
  }

  getParsedValues = fields => {
    const parsedValues = {};
    _.map(fields, field => {
      const key = field.fieldName;
      if (field.value) {
        // const value = _.compact(
        //   _.values(_.omit(field.value, ["__typename"]))
        // )[0];
        const value = JSON.parse(field.value);
        parsedValues[key] = value;
      } else {
        parsedValues[key] = null;
      }
    });

    return parsedValues;
  };

  next = () => {
    const currentStep = this.state.currentStep + 1;
    this.setState({ currentStep });
  };

  prev = () => {
    const currentStep = this.state.currentStep - 1;
    this.setState({ currentStep });
  };

  setStep = step => {
    this.setState({ currentStep: step - 1 });
  };

  render() {
    const { order, orderId } = this.props;
    const { serviceTitle, serviceSteps, fields, serviceId, status } = order;
    const { currentStep } = this.state;
    return (
      <UserContext.Consumer>
        {({ profile }) => (
          <React.Fragment>
            <Mutation mutation={UpdateOrderStatus}>
              {mutate => {
                return (
                  <Row gutter={32}>
                    <Row>
                      <h2>Solicitud de servicio</h2>
                      <p>{serviceTitle}</p>
                      <Divider />
                    </Row>
                    <Row gutter={{ md: 12, lg: 24, xl: 32 }}>
                      <Col xs={24} sm={24} md={12} lg={18} xl={18}>
                        <StepsForm
                          user={profile}
                          formFields={fields}
                          parsedValues={this.getParsedValues(fields)}
                          orderStatus={status}
                          serviceId={serviceId}
                          formSteps={serviceSteps}
                          currentStep={currentStep}
                          orderId={orderId}
                          next={this.next}
                          prev={this.prev}
                          setStep={this.setStep}
                          mutate={mutate}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                        <FormProgress
                          formSteps={serviceSteps}
                          currentStep={currentStep}
                        />
                      </Col>
                    </Row>
                  </Row>
                );
              }}
            </Mutation>
            <TermsModal orderId={orderId} order={order} user={profile} />
          </React.Fragment>
        )}
      </UserContext.Consumer>
    );
  }
}

export default ServiceRequest;



// WEBPACK FOOTER //
// ./src/Components/Services/ServiceRequest.js